import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListDockReservedIntervalsActions as Actions,
  ListDockReservedIntervalsRequestAction as RequestAction,
} from 'store/ducks/dockReservedIntervals';

export function* listDockReservedIntervalsRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('dock-reserved-intervals', {
      ...query,
      asList: 1,
      orderBy: 'startDate',
      direction: 'asc',
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
